// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-page,
.terms-page {
  max-width: 44rem;
  margin: 0 auto;
  padding: 1.5rem 1.25rem 3rem;
  color: var(--text-color, #f9fafb);
}

.privacy-page__body h2,
.terms-page__body h2 {
  margin: 1.75rem 0 0.5rem;
  font-size: 1.15rem;
  color: var(--text-color, #f9fafb);
}

.privacy-page__body p,
.privacy-page__body li,
.terms-page__body p,
.terms-page__body li {
  line-height: 1.55;
  color: var(--text-secondary, #9ca3af);
}

.privacy-page__body strong,
.terms-page__body strong {
  color: var(--text-color, #f9fafb);
  font-weight: 600;
}

.privacy-page__body a,
.terms-page__body a {
  color: var(--brand-primary-light, #0a8cd8);
  text-underline-offset: 2px;
}

.privacy-page__body a:hover,
.privacy-page__body a:focus-visible,
.terms-page__body a:hover,
.terms-page__body a:focus-visible {
  color: var(--brand-primary, #0877bc);
}

.privacy-page__body a:focus-visible,
.terms-page__body a:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
  border-radius: 2px;
}

.privacy-page__meta,
.terms-page__meta {
  font-size: 0.85rem;
  color: var(--text-secondary, #9ca3af);
}

.privacy-page__full,
.terms-page__full {
  margin-top: 1.5rem;
  font-size: 0.9rem;
}

.light-mode .privacy-page,
.light-mode .terms-page,
html[data-theme="light"] .privacy-page,
html[data-theme="light"] .terms-page {
  color: #111827;
}

.light-mode .privacy-page__body h2,
.light-mode .terms-page__body h2,
.light-mode .privacy-page__body strong,
.light-mode .terms-page__body strong,
html[data-theme="light"] .privacy-page__body h2,
html[data-theme="light"] .terms-page__body h2,
html[data-theme="light"] .privacy-page__body strong,
html[data-theme="light"] .terms-page__body strong {
  color: #111827;
}

.light-mode .privacy-page__body p,
.light-mode .privacy-page__body li,
.light-mode .terms-page__body p,
.light-mode .terms-page__body li,
.light-mode .privacy-page__meta,
.light-mode .terms-page__meta,
html[data-theme="light"] .privacy-page__body p,
html[data-theme="light"] .privacy-page__body li,
html[data-theme="light"] .terms-page__body p,
html[data-theme="light"] .terms-page__body li,
html[data-theme="light"] .privacy-page__meta,
html[data-theme="light"] .terms-page__meta {
  color: #374151;
}

.light-mode .privacy-page__body a,
.light-mode .terms-page__body a,
html[data-theme="light"] .privacy-page__body a,
html[data-theme="light"] .terms-page__body a {
  color: #065a8f;
}

.dark-mode .privacy-page,
.dark-mode .terms-page,
html[data-theme="dark"] .privacy-page,
html[data-theme="dark"] .terms-page {
  color: #f9fafb;
}

.dark-mode .privacy-page__body h2,
.dark-mode .terms-page__body h2,
.dark-mode .privacy-page__body strong,
.dark-mode .terms-page__body strong,
html[data-theme="dark"] .privacy-page__body h2,
html[data-theme="dark"] .terms-page__body h2,
html[data-theme="dark"] .privacy-page__body strong,
html[data-theme="dark"] .terms-page__body strong {
  color: #f9fafb;
}

.dark-mode .privacy-page__body p,
.dark-mode .privacy-page__body li,
.dark-mode .terms-page__body p,
.dark-mode .terms-page__body li,
.dark-mode .privacy-page__meta,
.dark-mode .terms-page__meta,
html[data-theme="dark"] .privacy-page__body p,
html[data-theme="dark"] .privacy-page__body li,
html[data-theme="dark"] .terms-page__body p,
html[data-theme="dark"] .terms-page__body li,
html[data-theme="dark"] .privacy-page__meta,
html[data-theme="dark"] .terms-page__meta {
  color: #d1d5db;
}

.dark-mode .privacy-page__body a,
.dark-mode .terms-page__body a,
html[data-theme="dark"] .privacy-page__body a,
html[data-theme="dark"] .terms-page__body a {
  color: #7dd3fc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/PrivacyNotice.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;;;EAIE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;;EAEE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;;;;;;;;;;;;EAYE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;;;;;;;;;;;;EAYE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB","sourcesContent":[".privacy-page,\n.terms-page {\n  max-width: 44rem;\n  margin: 0 auto;\n  padding: 1.5rem 1.25rem 3rem;\n  color: var(--text-color, #f9fafb);\n}\n\n.privacy-page__body h2,\n.terms-page__body h2 {\n  margin: 1.75rem 0 0.5rem;\n  font-size: 1.15rem;\n  color: var(--text-color, #f9fafb);\n}\n\n.privacy-page__body p,\n.privacy-page__body li,\n.terms-page__body p,\n.terms-page__body li {\n  line-height: 1.55;\n  color: var(--text-secondary, #9ca3af);\n}\n\n.privacy-page__body strong,\n.terms-page__body strong {\n  color: var(--text-color, #f9fafb);\n  font-weight: 600;\n}\n\n.privacy-page__body a,\n.terms-page__body a {\n  color: var(--brand-primary-light, #0a8cd8);\n  text-underline-offset: 2px;\n}\n\n.privacy-page__body a:hover,\n.privacy-page__body a:focus-visible,\n.terms-page__body a:hover,\n.terms-page__body a:focus-visible {\n  color: var(--brand-primary, #0877bc);\n}\n\n.privacy-page__body a:focus-visible,\n.terms-page__body a:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n.privacy-page__meta,\n.terms-page__meta {\n  font-size: 0.85rem;\n  color: var(--text-secondary, #9ca3af);\n}\n\n.privacy-page__full,\n.terms-page__full {\n  margin-top: 1.5rem;\n  font-size: 0.9rem;\n}\n\n.light-mode .privacy-page,\n.light-mode .terms-page,\nhtml[data-theme=\"light\"] .privacy-page,\nhtml[data-theme=\"light\"] .terms-page {\n  color: #111827;\n}\n\n.light-mode .privacy-page__body h2,\n.light-mode .terms-page__body h2,\n.light-mode .privacy-page__body strong,\n.light-mode .terms-page__body strong,\nhtml[data-theme=\"light\"] .privacy-page__body h2,\nhtml[data-theme=\"light\"] .terms-page__body h2,\nhtml[data-theme=\"light\"] .privacy-page__body strong,\nhtml[data-theme=\"light\"] .terms-page__body strong {\n  color: #111827;\n}\n\n.light-mode .privacy-page__body p,\n.light-mode .privacy-page__body li,\n.light-mode .terms-page__body p,\n.light-mode .terms-page__body li,\n.light-mode .privacy-page__meta,\n.light-mode .terms-page__meta,\nhtml[data-theme=\"light\"] .privacy-page__body p,\nhtml[data-theme=\"light\"] .privacy-page__body li,\nhtml[data-theme=\"light\"] .terms-page__body p,\nhtml[data-theme=\"light\"] .terms-page__body li,\nhtml[data-theme=\"light\"] .privacy-page__meta,\nhtml[data-theme=\"light\"] .terms-page__meta {\n  color: #374151;\n}\n\n.light-mode .privacy-page__body a,\n.light-mode .terms-page__body a,\nhtml[data-theme=\"light\"] .privacy-page__body a,\nhtml[data-theme=\"light\"] .terms-page__body a {\n  color: #065a8f;\n}\n\n.dark-mode .privacy-page,\n.dark-mode .terms-page,\nhtml[data-theme=\"dark\"] .privacy-page,\nhtml[data-theme=\"dark\"] .terms-page {\n  color: #f9fafb;\n}\n\n.dark-mode .privacy-page__body h2,\n.dark-mode .terms-page__body h2,\n.dark-mode .privacy-page__body strong,\n.dark-mode .terms-page__body strong,\nhtml[data-theme=\"dark\"] .privacy-page__body h2,\nhtml[data-theme=\"dark\"] .terms-page__body h2,\nhtml[data-theme=\"dark\"] .privacy-page__body strong,\nhtml[data-theme=\"dark\"] .terms-page__body strong {\n  color: #f9fafb;\n}\n\n.dark-mode .privacy-page__body p,\n.dark-mode .privacy-page__body li,\n.dark-mode .terms-page__body p,\n.dark-mode .terms-page__body li,\n.dark-mode .privacy-page__meta,\n.dark-mode .terms-page__meta,\nhtml[data-theme=\"dark\"] .privacy-page__body p,\nhtml[data-theme=\"dark\"] .privacy-page__body li,\nhtml[data-theme=\"dark\"] .terms-page__body p,\nhtml[data-theme=\"dark\"] .terms-page__body li,\nhtml[data-theme=\"dark\"] .privacy-page__meta,\nhtml[data-theme=\"dark\"] .terms-page__meta {\n  color: #d1d5db;\n}\n\n.dark-mode .privacy-page__body a,\n.dark-mode .terms-page__body a,\nhtml[data-theme=\"dark\"] .privacy-page__body a,\nhtml[data-theme=\"dark\"] .terms-page__body a {\n  color: #7dd3fc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
